import React from 'react';
//import { Link } from "react-router-dom";
import axios from "axios";
//import {Redirect} from 'react-router-dom';
import logoreg from "../abc.png"
import Path from "./config";
class admin_login extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sbg_mobile_no: "",
            sbg_email_id: "",
            islogin: false,
            sbg_id: ''
        }

    }
    componentDidMount() {
        //console.log("history===========",this.props.location.search);
        // const sbg_id = this.props.match.params.sbg_id;
        let webid = new URLSearchParams(this.props.location.search);
        let webidnew = webid.get("sbg_id");
        // this.setState({
        //     sbg_id:this.props.match.params.sbg_id
        // })
        //console.log("url value",sbg_id)

        if (webidnew !== null) {
            localStorage.setItem("userId", webidnew);

            this.props.history.push(`./FormProfile/Fullbiodata`);
        }
        else {

        }

    }

    mobileHandler = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_ad_mobile: e.target.value })
        }
    }
    passwordHandler = (e) => {
        this.setState
            ({ sbg_ad_password: e.target.value })
    }

    submitClick = (e) => {

        // e.preventDefault();
        let tempStr = "sbg_ad_mobile=" + this.state.sbg_ad_mobile +
            "&sbg_ad_password=" + this.state.sbg_ad_password
        // console.log(Login)
        axios.post(Path + `Suchi_bride_groom_admin_login.php?` + tempStr)
            .then(function (response) {
                //console.log("rrrrrrrrrrrrrrrrrrrrrr",response.data.sbg_ad_id);

                if (response.data.result === "LoginSuccess") {

                    let user = "Admin";
                    localStorage.setItem("adminid", response.data.sbg_ad_id);
                    localStorage.setItem("admin", user);
                    this.props.history.push(`/AdminProfile`);
                }


                else {
                    alert("अवैध मोबाइल नंबर किंवा संकेतशब्द कृपया पुन्हा प्रविष्ट करा");
                }

            }.bind(this))
    }

    cancleClick = () => {
        this.props.history.push(`/`);
    }


    render() {




        return (
            <>
                <div className="container-fluid ">
                    <span className="align-middle d-flex justify-content-center"><img src={logoreg} alt="logo" style={{ width: "300px" }}></img></span>

                    <div className="row justify-content-md-center my-5 ">
                        <form className="row justify-content-md-center">
                            <div className="col-md-5 border  border-5 p-3 mb-2 bg-light text-dark">
                                <div className="mb-3  ">
                                    <span className="d-block p-2 bg-danger text-white text-md-center text-capitalize">Admin Login</span>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="formGroupExampleInput" className="form-label">मोबईल नंबर </label>
                                    <input type="text" maxLength="13" className="form-control" value={this.state.sbg_ad_mobile} onChange={this.mobileHandler} placeholder="Mobile Number" />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="formGroupExampleInput" className="form-label">पासवर्ड  </label>
                                    <input type="password" autoComplete="true" className="form-control" value={this.state.sbg_ad_password} onChange={this.passwordHandler} placeholder="Password" />
                                </div>

                                <div className="mb-3 text-center my-5">
                                    {/* <Link to="/Otpcomfirm"> */}
                                    <button type="button" className="btn btn-success m-2" onClick={(e) => this.submitClick()}> Login ▶️ </button>
                                    {/* </Link> */}
                                    <button type="button" className="btn btn-primary" onClick={() => this.cancleClick()}> Cancel ❎ </button>
                                </div>
                            </div>.
                        </form>
                    </div>

                </div>

            </>
        )
    }
}

export default admin_login

